import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { Information } from "../../../domain/information/Information";
import { InformationId } from "../../../domain/information/InformationId";
import { InformationTitle } from "../../../domain/information/InformationTitle";
import { InformationContent } from "../../../domain/information/InformationContent";
import { DateTime } from "../../../domain/fundamental/DateTime";

export const useInformationList = (): Information[] | null => {
    const responseJsonArray = useSelector((state: State) => state.information.informations);

    // お知らせ情報の取得はDropDown.tsxにて行う

    return responseJsonArray ? responseJsonArray.map(responseJson => (
        Information.from(
            InformationId.fromString(responseJson.id),
            InformationTitle.fromString(responseJson.title),
            InformationContent.fromString(responseJson.content),
            DateTime.fromString(responseJson.createdTime),
            responseJson.isRead
        )
    )) : null;
};
